const addPolicyLink = (wrap) => {
  if (!wrap) return;

  const url = wrap.dataset.url;
  if (!url) return;

  // すでにリンク化済みなら何もしない
  if (wrap.querySelector('a[data-acceptance-link="privacy"]')) return;

  // 文言が入っている要素（CF7のラベルテキスト）
  const labelEl = wrap.querySelector(".wpcf7-list-item-label");
  if (!labelEl) return;

  const text = labelEl.textContent ?? "";
  const keyword = "プライバシーポリシー";

  // キーワードが無いなら何もしない
  if (!text.includes(keyword)) return;

  // 既存の内容を安全に組み直す（文字列置換でHTMLを壊しにくくする）
  const before = text.split(keyword)[0];
  const after = text.split(keyword).slice(1).join(keyword);

  // 中身を作り直す
  labelEl.textContent = ""; // いったん空に

  labelEl.append(document.createTextNode(before));

  const a = document.createElement("a");
  a.href = url;
  a.target = "_blank";
  a.rel = "noopener noreferrer";
  a.dataset.acceptanceLink = "privacy";
  a.textContent = keyword;
  labelEl.append(a);

  labelEl.append(document.createTextNode(after));
};
